export default "__VITE_ASSET__978bd40d__"